import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  unitInfo: {
    display: 'flex',
    '& + &': {
      marginTop: '24px'
    }
  },
  fieldMd: {
    width: '155px',
    marginLeft: '10px',
    flexShrink: '0'
  },
  fieldXs: {
    width: '140px',
    flexShrink: '0',
    '& + &': {
      marginLeft: '10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '100px'
    }
  },
  fullWidth: {
    flexGrow: '1'
  },
  success: {
    backgroundColor: palette.success.light,
    borderColor: palette.success.main,
    color: palette.success.dark,
    '& .MuiSvgIcon-root path': {
      fill: palette.success.main
    }
  },
  actions: {
    display: 'flex',
    '& .MuiButton-root': {
      border: "1px solid ".concat(palette.shades[500]),
      padding: '11px',
      backgroundColor: palette.shades[100],
      justifyContent: 'flex-start'
    },
    '& .modal-trigger': {
      marginLeft: '10px'
    }
  },
  smButton: {
    maxWidth: '150px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial'
    },
    '&.warningButton': {
      backgroundColor: "".concat(palette.warning.light),
      border: "1px solid ".concat(palette.warning.main),
      '&:hover': {
        backgroundColor: "".concat(palette.warning.light),
        border: "1px solid ".concat(palette.shades[700])
      }
    }
  },
  mdButton: {
    width: '160px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial'
    }
  },
  hideTablet: {
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'none'
    }
  },
  zeroRightRadius: {
    '& .MuiInputBase-root': {
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0'
    }
  },
  copyToAll: {
    position: 'relative',
    '& .MuiButton-root': {
      height: '48px',
      padding: '0 20px',
      borderLeft: 'none',
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0'
    },
    '&.hidden:after': {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      content: '""',
      display: 'block',
      position: 'absolute',
      background: '#f8f9fa'
    }
  },
  orderLast: {
    order: '1'
  }
}));
export default useStyles;